import * as data from './data'
export default {
  NEXT_STEP: ({
    commit
  }, operateObj) => {
    commit(data.NEXT_STEP, operateObj)
  },
  PREVIOUS_SETP: ({
    commit
  }, operateObj) => {
    commit(data.PREVIOUS_SETP, operateObj)
  },
  FINISH_SETP: ({
    commit
  }) => {
    commit(data.FINISH_SETP)
  },
  setToken: ({
    commit
  }, token) => {
    commit(data.SET_TOKEN, token)
  },
  setSeptInfo: ({
    commit
  }, info) => {
    commit(data.SET_SEPT_INFO, info)
  },

}



// WEBPACK FOOTER //
// ./src/store/actions.js